import { SubscriptionManager } from "@/js/SubscriptionManager"

export default function (H) {
  H.addEvent(H.Chart, 'load', function (e) {
    const chart = e.target
    chart.fincraft={
      subscriptionManager : new SubscriptionManager()
    }
  })

  H.addEvent(H.Chart, 'afterChange', function({target: chart, userOptions: {subscriptions}}) {
    const {fincraft} = chart
    if(!fincraft) return
    const {subscriptionManager} = fincraft

    subscriptionManager.clear()
    if(subscriptions){
      subscriptions.forEach(({subscription, trigger}) => {
        subscriptionManager.add(subscription, trigger, {chart})
      })
    }
  })

  H.addEvent(H.Chart, 'destroy', function ({target: chart}) {
    const { fincraft} = chart
    if(!fincraft) return
    const {subscriptionManager} = fincraft
    subscriptionManager.clear()
  })
}
